export interface CreateElementOptions extends Record<string, any> {
	children?: Array<HTMLElement | string | null | false>;
	attributes?: Record<string, string | number>;
	events?: Record<string, EventListener>;
}

export const createElement = <ElementInterface = HTMLElement>(
	elementType: string,
	options: CreateElementOptions
): ElementInterface => {
	const {
		children,
		attributes = {},
		events = {},
		...elementOptions
	} = options;
	const element = Object.assign(
		document.createElement(elementType),
		elementOptions
	) as ElementInterface & HTMLElement;

	Object.entries(attributes).forEach(([key, value]) => {
		element.setAttribute(key, String(value));
	});

	if (Array.isArray(children) && children.length) {
		const fragment = document.createDocumentFragment();
		children.filter(Boolean).forEach((child) => {
			if (child instanceof HTMLElement) {
				fragment.append(child);
			} else if (typeof child === 'string') {
				fragment.append(document.createTextNode(child));
			} else {
				console.warn('Unable to create a child element', child);
			}
		});
		element.appendChild(fragment);
	}

	Object.entries(events).forEach(([event, eventHandler]) => {
		element.addEventListener(event, eventHandler);
	});

	return element;
};
